/**
 * AppHost — widget-first (2.1).
 * Panels: pages/modules/apphost/panels.tsx
 * Catalog: module-ui-catalog → same widgets on /infra/nodes/:id
 */
import { useSearchParams } from 'react-router-dom';
import { requireModuleUi } from '../../widgets/module-ui-catalog';
import { ModuleWorkspace } from './ModuleWorkspace';

const DEF = requireModuleUi('apphost');

export default function AppHostPage() {
  const [searchParams] = useSearchParams();
  const tab = searchParams.get('tab');
  const defaultTab = tab && DEF.tabs.some((x) => x.id === tab) ? tab : 'instances';
  return <ModuleWorkspace def={DEF} hideHeader defaultTab={defaultTab} />;
}

export { AppHostServiceEditor } from './apphost/panels';
